// Copyright 2025. WebPros International GmbH. All rights reserved.

export const DELETE_CONFIRMATION: string = 'delete';